const isDevelopment = process.env.NODE_ENV === 'development';

const config = {
  apiUrl: isDevelopment ? 'http://localhost:5001/api' : '/api'
};

export default config; 